import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSnackbar } from "notistack";
import TabHeaderComponent from "../../../Components/Navigations/SimpleTabHeaderComponent";
import TabPanelComponent from "../../../Components/Navigations/SimpleTabPanelComponent";
import ControleDocaConfiguracaoFundoTab from "../ControleDoca/ControleDocaConfiguracaoFundoTab";
import PopupBasePage from "../../../Components/Base/BasePopup";
import { ConeLogisticoConfiguracao } from "../../../Models/Paineis/ConeLogistico/ConeLogisticoConfiguracao";

import { ControleDocaConfiguracao } from "../../../Models/Paineis/ControleDoca/ControleDocaConfiguracao";
import { FileUploadService } from "../../../Services/Bases/FileUploadService";
import { Usuario } from "../../../Models/Cadastros/Usuario/Usuario";

const ControleDocaConfiguracaoPopup = (props: any) => {
    const [tabValue, setTabValue] = React.useState(0);
    const [usuario, setUsuario] = useState<any>(new Usuario());
    

    const [controleDocaConfiguracao, setDocaConfiguracao] = useState<any>(new ControleDocaConfiguracao());
    const [docaConfiguracaoInicial, setConeConfiguracaoInicial] = useState<any>(new ConeLogisticoConfiguracao());
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        (async () => {
            await loadStyleCone();
        })();
    }, []);
    
    useEffect(() => {
        setDefaultDocaConfiguracao();
        setTimeout(setColorDocaConfiguracao, 1000);
    }, [controleDocaConfiguracao]);

    async function loadStyleCone() {
        let response: any = await axios.get(`controleDocaConfiguracao`);
        if (response.data != null && response.data != "") {
            setDocaConfiguracao(response.data);
        }
    }
    
    function setColorDocaConfiguracao()
    {
        for (const [key, value] of Object.entries(controleDocaConfiguracao)) {
            if (value == '' || value == null)
            {
                continue;
            }
            
            let colorClass = `area_${key}`;
            let elements = document.getElementsByClassName(colorClass) as HTMLCollectionOf<HTMLElement>;
            if (elements.length == 0)
            {
                elements = document.getElementsByClassName(key) as HTMLCollectionOf<HTMLElement>;
                if (elements.length > 0) {
                    elements[0].innerHTML = `${value}`;
                }

                continue;
            }

            Array.prototype.forEach.call(elements,
                function(element: any) {
                    setColor(key, element, value);
                }
            );
        }
    }

    function setColor(key: string, element: any, value: {}) {
        element.style['background-color'] = value;
    }

    function setDefaultDocaConfiguracao()
    {
        console.table(docaConfiguracaoInicial);
        for (const [key, value] of Object.entries(docaConfiguracaoInicial)) {
            let colorClass = `area_${key}`;
            
            let elements = document.getElementsByClassName(colorClass) as HTMLCollectionOf<HTMLElement>;
            if (elements.length == 0)
            {
                docaConfiguracaoInicial[key] = '';
                continue;
            }

            Array.prototype.forEach.call(elements,
                function(element: any) {
                    if (key == 'cor_fonte_titulo') {
                        docaConfiguracaoInicial[key] = element.style['color'];
                    }
                    else if (key == 'cor_fundo') {
                        docaConfiguracaoInicial[key] = element.style['background-color'];
                    }
                    else {
                        docaConfiguracaoInicial[key] = element.style['fill'];
                    }

                    return;
            });
        }

        console.log(docaConfiguracaoInicial);
    }

    function colorChangedCallback(field: string, type: string)
    {
        let colorClass = `area_${field}`;

        let elements = document.querySelectorAll(`#formControleDocasConfiguracoes .${colorClass}`);
        if (elements.length == 0)
        {
            return;
        }

        let valueInicial = docaConfiguracaoInicial[field];
        let valueNovo = controleDocaConfiguracao[field];
        Array.prototype.forEach.call(elements,
            function(element: any) {
            //console.log(valueNovo + ' - ' + valueInicial);
            if (valueNovo == null || valueNovo == "")
            {
                setColor(field, element, valueInicial);
            }
            else {
                setColor(field, element, valueNovo);
            }  
        });
    }

    
    function textFieldChangedCallback(field: string, text: string) {
        console.log(field)
        console.log(text)
        let elements = document.querySelectorAll(`#formControleDocasConfiguracoes .${field}`);
        if (elements.length == 0)
        {
            return;
        }

        elements[0].innerHTML = text;
    }

    async function saveAsync() {
        try {
            const imageUploaded = await (new FileUploadService()).uploadImageAsync(controleDocaConfiguracao, 'logotipo');
            if (!imageUploaded){
                enqueueSnackbar('Erro ao salvar imagem!', { variant: 'error' });
                return;
            }

            if (controleDocaConfiguracao?.id == null || controleDocaConfiguracao?.id == 0 || controleDocaConfiguracao?.id == '') {
                await axios.post('controleDocaConfiguracoes', controleDocaConfiguracao);
            }
            else {
                await axios.put(`controleDocaConfiguracoes/${controleDocaConfiguracao.id}`, controleDocaConfiguracao);
            }

            enqueueSnackbar('Salvo com sucesso!', { variant: 'success' });
            let response: any = await axios.get(`controleDocaConfiguracao`);
            setDocaConfiguracao(response.data);
        } catch (error) {
            enqueueSnackbar('Erro ao salvar!', { variant: 'error' });
        }
        finally {
            document.body.style.cursor = "default";
        }
    }

    return (
        <PopupBasePage title="Painel de Docas Configuração" isOpen={props.isOpen} onClose={props.onClose} onClickFirstButtonPopupCallback={saveAsync} isPesquisa='false' confirmClose={true}>
            <div className="container">
                <div className="row">
                    <div className="align-all-left col-md-12 order-md-1">
                        <TabHeaderComponent setTabValueEventCallBack={setTabValue} label="Painel de Docas" tabs={['Painel de Docas']} tab="cone" />

                        <form className="needs-validation" id="formControleDocasConfiguracoes">
                            <TabPanelComponent value={tabValue} index={0} tab="fundo" tabHeader="cone">
                                <ControleDocaConfiguracaoFundoTab controleDocaConfiguracao={controleDocaConfiguracao} colorChangedCallback={colorChangedCallback}  />
                            </TabPanelComponent>
                        </form>
                    </div>
                </div>
            </div >
        </PopupBasePage>
    );
}

export default ControleDocaConfiguracaoPopup;
